import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InventoryItemGroup } from 'src/app/models/results/inventory-item-group';

@Component({
  selector: 'app-compare-results',
  templateUrl: './compare-results.component.html',
  styleUrls: ['./compare-results.component.scss']
})
export class CompareResultsComponent {
  @Input()
  compareResultsList!: Array<InventoryItemGroup | null>;

  @Output() onRemoveCompareItem: EventEmitter<any> = new EventEmitter();

  constructor() { }


  onRemoveItem(event: any){
    this.compareResultsList = this.compareResultsList.map((item: any) => {
      if(item?.primaryItem?.materialID === event?.primaryItem?.materialID){
        item = null
      }
      return item
    })
    event.isDeviceBeingCompared = false
    this.onRemoveCompareItem.emit(event)
  }

}
